module.exports = __webpack_public_path__ + "img/logo.e6222a02.png";